window.addEventListener('load', (event) => {
  document
    .querySelectorAll('#tab_specifications .rte')
    .forEach(metafieldsRteToList);
  validateDataStrcuture(document.querySelector('#tab_talla'));
});

/**
 * Convierte contenido RTE (párrafos o <br>) en <ul class="metafields-spec-list">.
 * No toca bloques que ya tienen listas HTML.
 */
function metafieldsRteToList(rte) {
  if (!rte || rte.getAttribute('data-metafields-list') === '1') return;

  var firstChild = rte.firstElementChild;
  if (firstChild && (firstChild.tagName === 'UL' || firstChild.tagName === 'OL')) {
    rte.setAttribute('data-metafields-list', '1');
    return;
  }

  var blockEls = Array.prototype.filter.call(rte.children || [], function (el) {
    return el.tagName === 'P' || el.tagName === 'DIV';
  });

  function buildList(htmlParts) {
    var filtered = htmlParts.map(function (s) {
      return s.replace(/^\s+|\s+$/g, '');
    }).filter(Boolean);
    if (!filtered.length) return false;
    var ul = document.createElement('ul');
    ul.className = 'metafields-spec-list';
    filtered.forEach(function (html) {
      var li = document.createElement('li');
      li.innerHTML = html;
      ul.appendChild(li);
    });
    rte.textContent = '';
    rte.appendChild(ul);
    rte.setAttribute('data-metafields-list', '1');
    return true;
  }

  if (blockEls.length > 1) {
    var parts = blockEls.map(function (el) {
      return el.innerHTML;
    });
    if (buildList(parts)) return;
  }

  if (blockEls.length === 1 && /<br\s*\/?>/i.test(blockEls[0].innerHTML)) {
    if (buildList(blockEls[0].innerHTML.split(/<br\s*\/?>/i))) return;
  }

  var raw = rte.innerHTML.trim();
  if (/<br\s*\/?>/i.test(raw) && !/^<(p|div)[\s>]/i.test(raw)) {
    if (buildList(raw.split(/<br\s*\/?>/i))) return;
  }

  if (blockEls.length === 1) {
    if (buildList([blockEls[0].innerHTML])) return;
  }

  var text = rte.textContent.replace(/^\s+|\s+$/g, '');
  if (text && !rte.querySelector('ul, ol')) {
    var lines = text.split(/\n+/).map(function (l) {
      return l.trim();
    }).filter(Boolean);
    if (lines.length > 1) {
      var ul = document.createElement('ul');
      ul.className = 'metafields-spec-list';
      lines.forEach(function (line) {
        var li = document.createElement('li');
        li.textContent = line;
        ul.appendChild(li);
      });
      rte.textContent = '';
      rte.appendChild(ul);
      rte.setAttribute('data-metafields-list', '1');
    }
  }
}


function openCity(evt, cityName) {
    // Declare all variables
    var i, tabcontent, tablinks;

    // Get all elements with class="tabcontent" and hide them
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
    }

    // Get all elements with class="tablinks" and remove the class "active"
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
    }

    // Show the current tab, and add an "active" class to the button that opened the tab
    document.getElementById(cityName).style.display = "block";
    evt.currentTarget.className += " active";
}
var defaultOpenEl = document.getElementById('defaultOpen');
if (defaultOpenEl) defaultOpenEl.click();

/* Modal vídeo metafields — desactivado junto a la pestaña VIDEO en metafields_tabs.liquid; descomentar al reactivar.
(function initMetafieldsVideoModal() {
  var container = document.querySelector('.video-modal-trigger');
  var modal = document.getElementById('metafields-video-modal');
  if (!container || !modal) return;

  if (modal.parentNode !== document.body) {
    document.body.appendChild(modal);
  }

  var inlineVideo = container.querySelector('video');
  var modalVideo = modal.querySelector('.metafields-video-modal__player');
  var closeBtn = modal.querySelector('.metafields-video-modal__close');
  var backdrop = modal.querySelector('.metafields-video-modal__backdrop');
  if (!inlineVideo || !modalVideo || !closeBtn || !backdrop) return;

  function getVideoSrc() {
    var fromData = container.getAttribute('data-video-src');
    if (fromData) return fromData;
    return inlineVideo.currentSrc || inlineVideo.src;
  }

  function openModal() {
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    modalVideo.src = getVideoSrc();
    modalVideo.muted = false;
    inlineVideo.pause();
    modalVideo.play().catch(function () {});
    closeBtn.focus();
  }

  function closeModal() {
    modalVideo.pause();
    modalVideo.removeAttribute('src');
    modalVideo.load();
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    inlineVideo.play().catch(function () {});
  }

  container.addEventListener('click', function (e) {
    e.preventDefault();
    openModal();
  });

  container.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      openModal();
    }
  });

  closeBtn.addEventListener('click', function (e) {
    e.stopPropagation();
    closeModal();
  });

  backdrop.addEventListener('click', closeModal);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) closeModal();
  });
})();
*/

function validateDataStrcuture(e) {
  if (e != null) {
    let currContent = e.outerHTML.split('>');
    let counterX = 1;
    let newUl = document.createElement('ul');
    currContent.forEach((x) => {
      let currValue = x.replace('\n', '').replace('<br', '').replace('</div', '').replace('<br>', '');
      if (counterX > 1 && counterX != currContent.length) {
        let newLi = document.createElement('li');
        newLi.innerText = currValue;
        newUl.appendChild(newLi);
      }
      counterX++;
    });

    let children = e.childNodes;
    for (const node of children) {
      e.removeChild(node);
    }

    e.appendChild(newUl);
  }
}
